import * as React from 'react';

import './Stack.css';


function Stack({children, direction}: {children: React.ReactNode, direction: "row" | "column"}): React.JSX.Element {
    const classes = `Stack Stack-${direction}`;

    return (
        <div className={classes}>{children}</div>
    );
}


export default Stack;
